#!/usr/bin/env node

import * as fs from 'fs';
import { Stats } from 'fs';
import { extractNodeArguments } from './NodeArgumentsUtils';

/**
 *
 * Created by Alexander Hadzhimitov on 19-Nov-2018.
 */

/**
 * Extract list of files from a given URL
 */
export class FilesReader
{
	// -----------------------------------------
	// STATIC PROPERTIES/METHODS
	// -----------------------------------------
	
	// -----------------------------------------
	// PUBLIC PROPERTIES
	// -----------------------------------------
	
	// -----------------------------------------
	// PROTECTED PROPERTIES
	// -----------------------------------------
	
	// -----------------------------------------
	// PRIVATE PROPERTIES
	// -----------------------------------------
	
	// -----------------------------------------
	// CONSTRUCTOR
	// -----------------------------------------
	
	constructor()
	{
		//console.log("BarrelGenerator.constructor", "Generation started !");
	}
	
	// -----------------------------------------
	// PUBLIC METHODS
	// -----------------------------------------
	
	// -----------------------------------------
	// PROTECTED METHODS
	// -----------------------------------------
	public async extractFiles(folderURL: string): Promise<string[]>
	{
		// we need to convert file path format to URI format
		folderURL.replace(/\\/g, '/');
		
		let isFolder = await new Promise((resolve, reject) => fs.stat(folderURL,
			(error, stats: Stats) => {
				
				if (error)
				{
					console.log('Error reading folder:', error.path);
					reject(false);
				} else
				{
					resolve(stats.isDirectory());
				}
			}));
		
		//fs.statSync(folderURL).isDirectory();
		
		if (!isFolder)
		{
			return [folderURL];
		}
		
		let filesList: string[] = await this.readFolder(folderURL);
		
		folderURL = addSlash(folderURL, '/');
		
		filesList = this.expandURLS(folderURL, filesList);
		
		//console.log("expandURLS:", filesList);
		
		return await Promise.all<string>(filesList.map(this.extractFiles.bind(this)));
	}
	
	
	// -----------------------------------------
	// PRIVATE METHODS
	// -----------------------------------------
	private readFolder(url: string): Promise<string[]>
	{
		return new Promise<string[]>((resolve, reject) => {
			//fs.readdir(url, (error, files) => resolve(files));
			
			try
			{
				resolve(fs.readdirSync(url));
			}
			catch (error)
			{
				reject(error);
			}
			
			
		});
	}
	
	private expandURLS(baseURL: string, files: string[]): string[]
	{
		return files.map((fileURL) => baseURL.concat(fileURL));
	}
	
}

/**
 * Logic for creating Index.ts, with re-export for all *.ts files.
 */
export class BarrelWriter
{
	
	private splitString: string = '';
	
	constructor()
	{
	
	}
	
	public async createBarrel(url: string, conf: BarrelConfigType, splitString: string, files: string[]): Promise<any>
	{
		this.splitString = splitString;
		
		console.log(this.constructor.name + ".createBarrel", "url:", url, "conf:", conf);
		
		if (url.charAt(url.length - 1) !== '\\')
		{
			url = url.concat('\\');
		}
		
		let barrelFileLocation = conf.barrelFileLocation;
		
		if (barrelFileLocation)
		{
			if (barrelFileLocation.charAt(url.length - 1) !== '\\'
				|| barrelFileLocation.charAt(url.length - 1) !== '/')
			{
				barrelFileLocation = barrelFileLocation.concat('\\');
			}
		}
		
		if (barrelFileLocation)
		{
			url = url.concat(barrelFileLocation);
		}
		
		let indexUrl = url.concat(conf.barrelFileName);
		
		console.log('Barrel file path:', indexUrl);
		
		let fileCreated = await new Promise((resolve, reject) => {
			fs.open(indexUrl, 'w', (error, file) => {
				
				if (file)
				{
					console.log("Index.ts created at url:", url);
					resolve(file);
				} else
				{
					console.log("Error creating file:", url);
					reject(false);
				}
				
			});
		});
		
		if (fileCreated)
		{
			console.log("Start writing index.ts", "");
			
			let fileString = '';
			files.forEach(file => {
				file = `export * from '${file}' \n`;
				fileString = fileString.concat(file);
			});
			
			//console.log("Write string:", fileString);
			
			return await new Promise((resolve, reject) => {
				fs.appendFile(indexUrl, fileString, (err) => {
					if (err)
					{
						console.log("Error writing into file:", url);
						reject(err)
					}
					resolve(true);
				});
			});
			
		}
		
		return Promise.reject("Error generating Index.ts !!!");
	}
	
}

function flattenArray<T>(arr1: T[]): T[]
{
	return arr1.reduce((acc: any, val: any) => Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val), []);
}

function addSlash(url: string, slash: "/" | "\\" = "/"): string
{
	if ((url.charAt(url.length - 1) !== slash))
	{
		//console.log('Add slash to url:', url);
		url = url.concat(slash);
	}
	
	return url;
}


/**
 * This is the default folder which the Barrel Generator will scan
 * and produce a barrel file for.
 */
const SOURCE_FOLDER_DEFAULT = './';

/**
 * By default this are files/file extensions which we want to exclude from the barrel.
 */
const EXCLUDE_FILES_DEFAULT = ['d.ts', 'spec.ts', 'index.ts'];

/**
 * Default extension of the files included in index.ts
 */
const INCLUDE_FILE_DEFAULT = '.ts';

/**
 * Default name for the barrel file.
 */
const BARREL_FILE_NAME_DEFAULT = 'index.ts';

/**
 * The location where the barrel files will be created.
 * Generally it is one folder bellow the source folder.
 */
const BARREL_FILE_LOCATION_DEFAULT = './';

type BarrelConfigType = {
	sourceFolder: string,
	barrelFileName: string,
	barrelFileLocation: string,
	includeFile: string,
	excludeFiles: string[],
}

let config: BarrelConfigType = {
	sourceFolder: SOURCE_FOLDER_DEFAULT,
	barrelFileName: BARREL_FILE_NAME_DEFAULT,
	barrelFileLocation: BARREL_FILE_LOCATION_DEFAULT,
	includeFile: INCLUDE_FILE_DEFAULT,
	excludeFiles: EXCLUDE_FILES_DEFAULT
};

async function main(url: string, excludes: string[], include: string)
{
	const filesReader = new FilesReader();
	const barrelWriter = new BarrelWriter();
	
	let tempConfig = extractNodeArguments<BarrelConfigType>(process.argv);
	
	config = {...config, ...tempConfig};
	
	console.log('Barrel Config', {...config});
	
	let tsURLS: string[] = await filesReader.extractFiles(config.sourceFolder);
	
	
	tsURLS = flattenArray(tsURLS);
	
	// console.log(".main", "tsURLS", tsURLS);
	
	// We need to clear the barrel url from the path to each file.
	if (config.sourceFolder.indexOf(config.barrelFileLocation) === 0)
	{
		console.log('Barrel file located within source folder !');
		let barelFileUrlLength = config.barrelFileLocation.length;
		tsURLS = tsURLS.map<string>((tempUrl) => {
			const s = "." + tempUrl.slice(barelFileUrlLength, tempUrl.length);
			return s;
		})
	}
	
	excludes.forEach(excludeString => {
			tsURLS = tsURLS.filter(file => !file.includes(excludeString));
		}
	);
	
	let finaLURLS: string[] = tsURLS.filter(file => file.includes(include));
	
	let excludeTSRegEx = new RegExp(include + '$', 'g');
	
	finaLURLS = finaLURLS.map(u => u.replace(excludeTSRegEx, ''));
	
	//console.log("Barrel files:", finaLURLS);
	
	return await barrelWriter.createBarrel(url, config, include, finaLURLS);
}

console.log("/** Barrel Generation Started **/");


main(SOURCE_FOLDER_DEFAULT, EXCLUDE_FILES_DEFAULT, INCLUDE_FILE_DEFAULT).then(() => {
	console.log("/** Barrel Generation Completed **/");
}).catch(error => console.log("Error on Barrel generation !!!", error));




